import { Search } from 'lucide-react'
import { cn } from '../../lib/utils.js'

function SearchInput({
  className,
  iconSize = 17,
  inputClassName,
  ...props
}) {
  return (
    <label className={cn('ui-search-input', className)}>
      <Search size={iconSize} aria-hidden="true" />
      <input type="search" className={inputClassName} {...props} />
    </label>
  )
}

export { SearchInput }
